// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Action } from '@ngrx/store';
import { ProjectDetail } from '@app/core/models';

export enum ProjectsActionTypes {
  PROJECT_DETAILS_LOADING = '[Projects] PROJECT_DETAILS_LOADING',
  PROJECT_DETAILS_LOAD_COMPLETE = '[Projects] PROJECT_DETAILS_LOAD_COMPLETE',
  PROJECT_DETAILS_LOAD_FAILED = '[Projects] PROJECT_DETAILS_LOAD_FAILED',
}

export class LoadingProjectDetailsAction implements Action {
  readonly type = ProjectsActionTypes.PROJECT_DETAILS_LOADING;
  readonly payload: { projectId: string };
  constructor(projectId: string) {
    this.payload = { projectId };
  }
}

export class CompleteLoadProjectDetailsAction implements Action {
  readonly type = ProjectsActionTypes.PROJECT_DETAILS_LOAD_COMPLETE;
  constructor(public payload: ProjectDetail) {
    this.payload = payload;
  }
}

export class FailLoadProjectDetailsAction implements Action {
  readonly type = ProjectsActionTypes.PROJECT_DETAILS_LOAD_FAILED;
  readonly payload: { projectId: string };
  constructor(projectId: string) {
    this.payload = { projectId };
  }
}

export type ProjectsActionsUnion =
  | LoadingProjectDetailsAction
  | CompleteLoadProjectDetailsAction
  | FailLoadProjectDetailsAction;



// WEBPACK FOOTER //
// ./src/app/core/state/projects.actions.ts